// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;
 
export const BASEURL = `https://star-omanstg-api.nuviotech.co`;
 
// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://star-omanstg-api.nuviotech.co`;
 
export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const STAR_OMAN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6Ijg2ZGMxZWZiLTM2ODAtNDBlNS1iYWEzLTg5OGRmNDFlYzYwMiIsImlhdCI6MTczMjM4NjgxMn0.AvILSoBpzRIsQOfaeP3K6zhvM8U-iVYZ6dOw45-R8bk`
export const TOKEN = STAR_OMAN



// WEBPACK FOOTER //
// ./src/config/index.js